import { type FC } from "react";
import { type Dayjs } from "dayjs";
import { useAppDispatch } from "@/services/store";
import { calendarSliceActions } from "@/features/calendar/model";
import { capitalizeString } from "@/shared/utils/capitalize";
import type { DateChangeTypes } from "./types";
import styles from "./styles.module.scss";
import { Arrows } from "./Arrows";

type CalendarHeaderProps = {
  value: Dayjs;
};

export const CalendarHeader: FC<CalendarHeaderProps> = ({ value }) => {
  const dispatch = useAppDispatch();

  const changeDateHandler = (type: DateChangeTypes) => {
    switch (type) {
      case "nextYear":
        dispatch(calendarSliceActions.updateDateRange(value.add(1, "year").toISOString()));
        break;
      case "nextMonth":
        dispatch(calendarSliceActions.updateDateRange(value.add(1, "month").toISOString()));
        break;
      case "prevYear":
        dispatch(calendarSliceActions.updateDateRange(value.subtract(1, "year").toISOString()));
        break;
      case "prevMonth":
        dispatch(calendarSliceActions.updateDateRange(value.subtract(1, "month").toISOString()));
        break;
    }
  };

  return (
    <div className={styles.header}>
      <Arrows
        onDoubleArrowClick={() => changeDateHandler("prevYear")}
        onOneArrowClick={() => changeDateHandler("prevMonth")}
      />
      <div className={styles["calendar-header-date"]}>
        {capitalizeString(value.format("MMM"))} {value.format("YYYY")}
      </div>
      <Arrows
        position="right"
        onDoubleArrowClick={() => changeDateHandler("nextYear")}
        onOneArrowClick={() => changeDateHandler("nextMonth")}
      />
    </div>
  );
};
